import React, { useState } from "react";
import { useLanguage } from "../../../../context/LanguageContext";
import useCurrency from "../../../../hooks/useCurrency";

const DiscountSection = ({
  discountCode,
  setDiscountCode,
  onApplyDiscount,
  onRemoveDiscount,
  appliedPromo,
  promoLoading,
  promoError,
  processing,
  storeSettings,
}) => {
  const { language } = useLanguage();
  const { formatDisplay } = useCurrency();
  const [inputCode, setInputCode] = useState(discountCode || "");

  // Translations for discount section
  const translations = {
    en: {
      enterPromoCode: "Enter promo code",
      apply: "Apply",
      applying: "Applying...",
      remove: "Remove",
      off: "off",
    },
    ar: {
      enterPromoCode: "أدخل رمز الخصم",
      apply: "تطبيق",
      applying: "جاري التطبيق...",
      remove: "إزالة",
      off: "خصم",
    },
  };

  const t = translations[language] || translations.en;

  const handleApplyDiscount = async () => {
    if (!inputCode.trim()) {
      return;
    }

    const success = await onApplyDiscount(inputCode.trim());
    if (success) {
      setDiscountCode(inputCode.trim().toUpperCase());
    }
  };

  const handleRemoveDiscount = () => {
    onRemoveDiscount();
    setDiscountCode("");
    setInputCode("");
  };

  const handleInputChange = (e) => {
    const value = e.target.value.toUpperCase();
    setInputCode(value);
    setDiscountCode(value);
  };

  // Use centralized currency formatting
  const formatCurrency = formatDisplay;

  const getDiscountDescription = () => {
    if (!appliedPromo) return "";

    if (appliedPromo.discountType === "percentage") {
      return `${appliedPromo.discountValue}% ${t.off}`;
    } else if (appliedPromo.discountType === "fixed") {
      return `${formatCurrency(appliedPromo.discountValue)} ${t.off}`;
    }
    return "";
  };

  return (
    <div className="os-promo-code-section">
      {!appliedPromo ? (
        <div className="os-promo-code-input">
          <input
            type="text"
            className="os-promo-input"
            placeholder={t.enterPromoCode}
            value={inputCode}
            onChange={handleInputChange}
            disabled={processing || promoLoading}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleApplyDiscount();
              }
            }}
            maxLength={20}
            dir={language === "ar" ? "rtl" : "ltr"}
          />
          <button
            type="button"
            className="os-apply-promo-btn"
            onClick={handleApplyDiscount}
            disabled={processing || promoLoading || !inputCode.trim()}
          >
            {promoLoading ? t.applying : t.apply}
          </button>
        </div>
      ) : (
        <div className="os-applied-promo">
          <div className="os-promo-success">
            <span className="os-promo-code-applied">
              ✓ {appliedPromo.code} - {getDiscountDescription()}
            </span>
            <button
              type="button"
              className="os-remove-promo-btn"
              onClick={handleRemoveDiscount}
              disabled={processing}
              title={t.remove}
            >
              {t.remove}
            </button>
          </div>
        </div>
      )}

      {promoError && <div className="os-promo-error">{promoError}</div>}
    </div>
  );
};

export default DiscountSection;
